import React from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppMeta } from "hooks";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useCreateDeliveryCollectionMutation } from "store/services/deliveryCollectionApi";

import DeliveryCollectionForm from "./DeliveryCollectionComponents/DeliveryCollectionForm";

const DeliveryCollectionCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Delivery Collections", path: "/app/crm/delivery-collection/list" },
    { title: "New Delivery Collection" }
  ];

  const [createDeliveryCollection, { isLoading: creatingDeliveryCollection }] = 
    useCreateDeliveryCollectionMutation();

  const handleAddDeliveryCollection = async (data) => {
    try {
      const response = await createDeliveryCollection(data).unwrap();
      const _id = response.data._id; // Extract _id from response.data
      console.log('Create DeliveryCollection Response:', response); // Debug log
      if (!_id) {
        throw new Error("DeliveryCollection ID not found in response");
      }
      toast.success("Delivery Collection Created!");
      navigate(`/app/crm/delivery-collection/${_id}/detail`);
    } catch (error) {
      console.error('Error creating DeliveryCollection:', error);
      toast.error(
        error?.data?.message ?? error.message ?? "Could not create Delivery Collection!"
      );
    }
  };

  useAppMeta("New Delivery Collection");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingDeliveryCollection}>
      <BreadcrumbLayout.Paper>
        <DeliveryCollectionForm
          isBusy={creatingDeliveryCollection} 
          onSubmit={handleAddDeliveryCollection} 
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default DeliveryCollectionCreateScreen;